// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__27x4t","inner":"Footer_inner__3mrzE"};